// @flow
const BREAKPOINTS = {
  XXS: 'XXS',
  XS: 'XS',
  S: 'S',
  M: 'M',
  L: 'L',
  XL: 'XL',
};

const ORDERED_BREAKPOINTS = [
  BREAKPOINTS.XXS,
  BREAKPOINTS.XS,
  BREAKPOINTS.S,
  BREAKPOINTS.M,
  BREAKPOINTS.L,
  BREAKPOINTS.XL,
];

const MEDIA_QUERIES = [
  {
    breakpoint: BREAKPOINTS.XXS,
    mediaquery: '(min-width: 0)',
  },
  {
    breakpoint: BREAKPOINTS.XS,
    mediaquery: '(min-width: 22.51em)',
  },
  {
    breakpoint: BREAKPOINTS.S,
    mediaquery: '(min-width: 40.01em)',
  },
  {
    breakpoint: BREAKPOINTS.M,
    mediaquery: '(min-width: 50.01em)',
  },
  {
    breakpoint: BREAKPOINTS.L,
    mediaquery: '(min-width: 64.01em)',
  },
  {
    breakpoint: BREAKPOINTS.XL,
    mediaquery: '(min-width: 76.26em)',
  },
];

const DEFAULT_CELL_COLS = { [BREAKPOINTS.XXS]: 12 };

export { BREAKPOINTS, ORDERED_BREAKPOINTS, DEFAULT_CELL_COLS, MEDIA_QUERIES };
